import React, { Component } from 'react';
import styled from 'styled-components';
import colors from 'utils/colors';
import map from 'lodash/map';
import forEach from 'lodash/forEach';
import { BorderWrapper } from 'components/styled-components';
import { Switch } from '@blueprintjs/core';
import AddAttachmentsSection from 'components/forms/questionnaire/add-attachments';
import hasPermission from 'utils/hasPermission';
import permissions from 'utils/permissions';
import { NonIdealState } from '@blueprintjs/core';
import ErrorWrapper from 'components/forms/components/error-wrapper';
import QuestionCategorySection from 'containers/Questionnaire/QuestionCategorySection';

class QuestionTypeSection extends Component {
  state = { optOut: false };

  componentDidMount() {
    this.checkIfOptOut(
      this.props.questionGroup.typeSection[0].categorySection[0]
    );
  }

  checkIfOptOut = ({ answers, selected }) => {
    const optOutID = answers.find(answer => answer.answer === 'OPT_OUT')
      .answerID;
    const optOut = selected.includes(optOutID);
    if (optOut) {
      this.setState({ optOut }, () => this.setAnswersToOptOut(true));
    }
  };

  toggleOptOut = () => {
    if (!this.state.optOut) {
      this.setState({ optOut: true });
      this.setAnswersToOptOut(true);
    } else {
      this.setState({ optOut: false });
      this.setAnswersToOptOut(false);
    }
  };

  setAnswersToOptOut = optOut => {
    forEach(this.props.questionGroup.typeSection, section => {
      forEach(section.categorySection, cSection => {
        if (optOut) {
          const selected = cSection.answers.find(
            answer => answer.answer === 'OPT_OUT'
          );
          this.props.setFieldValue(cSection.questionID, {
            ...cSection,
            selected,
          });
        } else {
          this.props.setFieldValue(cSection.questionID, {
            ...cSection,
            selected: [],
          });
        }
      });
    });
  };

  render() {
    const { questionGroup, errors } = this.props;
    return (
      <BorderWrapper id={`section-${this.props.questionGroup.typeID}`}>
        <CategoryHeader>
          <QuestionTitle>{questionGroup.key}</QuestionTitle>
          {!!!this.props.questionGroup.typeSection[0].categorySection[0]
            .questionType.mandatory && (
            <Switch
              label="Opt out of this section and upload document(s)"
              onChange={this.toggleOptOut}
              large
              checked={this.state.optOut}
            />
          )}
        </CategoryHeader>
        <ConditionalDisplay shouldDisplay={this.state.optOut}>
          <CenterRow>
            {!hasPermission(this.props.appUser.permissions, [
              permissions.UPLOAD_QUESTIONNAIRE_ATTACHMENT,
              permissions.UPLOAD_ALL_QUESTIONNAIRE_ATTACHMENT,
            ]) ? (
              <NonIdealState
                icon="error"
                title="You do not have permission to upload files."
              />
            ) : (
              <div>
                <AddAttachmentsSection
                  handleOnDrop={this.props.handleOnDrop}
                  handleAttachmentRemove={this.props.handleAttachmentRemove}
                />
                {this.props.submitCount > 0 &&
                  this.props.attachments.length === 0 && (
                    <ErrorWrapper>{errors.attachments}</ErrorWrapper>
                  )}
              </div>
            )}
          </CenterRow>
        </ConditionalDisplay>
        <ConditionalDisplay shouldDisplay={!this.state.optOut}>
          {map(questionGroup.typeSection, (q, i) => (
            <QuestionCategorySection
              questionGroup={q}
              step={i + 1}
              question={q}
              answers={q.answers}
              name={q.questionID}
              setFieldValue={this.props.setFieldValue}
              handleChange={this.props.handleChange}
              values={this.props.values}
              key={i}
              shouldOptOut={this.state.shouldOptOut}
            />
          ))}
        </ConditionalDisplay>
      </BorderWrapper>
    );
  }
}

export default QuestionTypeSection;

const CategoryHeader = styled.div`
  font-weight: 300;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid ${colors.lightestGray};
  background: ${colors.lightestGray};
  margin: 0;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const QuestionTitle = styled.span`
  font-size: 1.5rem;
`;

const CenterRow = styled.div`
  display: flex;
  justify-content: center;
`;

const ConditionalDisplay = styled.div`
  display: ${props => (props.shouldDisplay ? 'block' : 'none')};
`;
